import { render, staticRenderFns } from "./ViewMenuItemImages.vue?vue&type=template&id=8b1870ec&scoped=true&"
import script from "./ViewMenuItemImages.vue?vue&type=script&lang=js&"
export * from "./ViewMenuItemImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1870ec",
  null
  
)

export default component.exports